import React from 'react'
import { observer } from 'mobx-react'
import * as linkConst from '../../../constants/link_constants'
import DateField from 'react-mobx-admin/components/common/field/date'
import DateInput from '../../input/date'
import EmbededEntityInput from '../../input/embedded_entity'
import FlyPrivateCatsCopyModal from './flyprivate_cats_copy_modal'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import OptionSelect from 'bstrap-react-mobx-admin/new_src/input/option_select'
import RegionsInput from '../../input/regions'
import SelectInput from '../../input/select'
import TextField from 'react-mobx-admin/components/common/field/text'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import moment from 'moment'
import { Button } from 'react-bootstrap'

const FPrivateCategoriesEdit = ({ store, label, items, disabledEntityFromBatch, ...rest }) => {
  const _FPrivateCategoriesForm = observer(({ record, state, updateFormField, errors }) => {
    const { stageOneRestricted, stageTwoRestricted } = store.timeRestriction.checkSubentity(store, state)
    const dateRestriction = store.timeRestriction.flyprivateCategories
    const batchAction = store.router.params && store.router.params.operation && store.router.params.operation === linkConst.BATCH_ACTION_CATEGORIES
    const origRecord = record.has('id') && store.cv.origRecord.flyprivateCategories &&
      store.cv.origRecord.flyprivateCategories.find(i => i.id.toString() === record.get('id').toString())
    const disabled = stageOneRestricted
    const catPlatform = !disabled && store.getCatPlatform(store, state)
    const catPlatformFilter = !disabled ? store.getCatPlatformFilter(catPlatform) : undefined

    return (
      <div className='row'>
        {store.lastSaved && store.lastSaved.FPVFilmCategory && !record.has('updated') &&
          <div className='col-xs-12'><p>
            <Button bsStyle='primary' onClick={() => store.onAddClickedCats(store, record, items)}
              disabled={stageOneRestricted}>
              {store.__('+ Load data from the last saved item')}
            </Button>
          </p></div>}
        <div className='col-xs-12'>
          {!disabled && <OptionSelect
            attr='platformFilter' label={store.__('platform')} value={catPlatform}
            onChange={store.updateStorageField(store, state)}
            options={store.options.get('FlyPrivatePlatforms')}
            disabled={disabled} labelattr='text' errors={errors} />}
          <SelectInput attr='enum_value' label={store.__('category')} record={record}
            onChange={updateFormField} valueFilterFc={catPlatformFilter}
            optionsattr='FlyprivateCategories' optionsrecord={store.options} disabled={disabled}
            labelattr='text' valueattr='value' errors={errors} />
          <TextInput type='number' label={store.__('order')} attr={'order'}
            disabled={stageTwoRestricted || (stageTwoRestricted && origRecord.valid_to && origRecord.valid_to === record.get('valid_to'))}
            record={record} onChange={updateFormField} errors={errors} />
          {record.has('id') || (record.has('updated') && record.get('updated'))
            ? <SelectInput label={store.__('region')} attr={'regions'} labelattr='text' valueattr='value'
              record={record} onChange={updateFormField} errors={errors} disabled={stageOneRestricted}
              optionsrecord={store.options} optionsattr={'Countries'}
              valueFilterFc={val => (val.value && val.value.length > 2)} />
            : <RegionsInput label={store.__('regions')} attr={'regions'}
              record={record} onChange={updateFormField} hideCheckbox={batchAction}
              errors={errors} disabled={stageOneRestricted}
              optionsrecord={store.options} optionsattr={'Countries'} />}
          <DateInput label={store.__('valid from')} attr={'valid_from'}
            disabled={stageOneRestricted || (record.has('id') && record.get('valid_from') && moment(record.get('valid_from')).isSame(moment(), 'day'))}
            minDate={dateRestriction.valid_from.minDate}
            record={record} onChange={updateFormField} errors={errors} />
          <DateInput label={store.__('valid to')} attr={'valid_to'} disabled={stageTwoRestricted}
            record={record} onChange={updateFormField} errors={errors}
            minDate={dateRestriction.valid_to.minDateToday &&
              (!record.has('id') || (record.has('valid_from') && record.get('valid_from') &&
                moment(record.get('valid_from')).isSameOrAfter(dateRestriction.valid_to.minDateToday, 'day')))
              ? dateRestriction.valid_to.minDateToday
              : dateRestriction.valid_to.minDate}
          />
        </div>

        {store.manipWarning &&
          <div className='col-sm-12'>
            <div className='alert alert-dismissible alert-warning'>
              <p><strong>{store.__('WARNING').concat(': ')}</strong>
                {store.__('World wide (WW) region for this Category is missing (between valid from/to).')}
              </p>
            </div>
          </div>
        }

        {record.get('regions') && record.get('regions') !== 'WW' && record.get('regions').length > 2 &&
          <div className='col-sm-12'>
            <div className='alert alert-dismissible alert-warning'>
              <p><strong>{store.__('WARNING').concat(': ')}</strong>
                {store.__('Multiple regions will be divided into the separate items.')}
              </p>
            </div>
          </div>
        }
      </div>
    )
  })

  const attr = 'flyprivateCategories'
  const toSave = (saved, data) => {
    store.lastSaved = !store.lastSaved ? {} : store.lastSaved
    store.lastSaved.FPVFilmCategory = Object.assign({}, saved)
    saved.updated = new Date()
    if (data !== null) {
      Object.assign(data, saved)
    } else {
      saved.regions.split(',').map(i => {
        i && (items || store.cv.record.get(attr)).push(Object.assign(saved, { regions: i }))
      })
    }
    return saved
  }
  return (<React.Fragment>
    <EmbededEntityInput label={label} store={store} attr={attr}
      onAddRow={(saved) => toSave(saved, null)}
      onUpdateRow={(saved, data) => toSave(saved, data)}
      disabled={!!disabledEntityFromBatch}
      edit_title={store.__('edit FlyPrivate category')}
      add_title={store.__('add FlyPrivate category')}
      errors={store.cv.errors}
      fields={[
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => (
          <OptionsField attr={attr} val={row[attr]}
            options={store.options.get('FlyprivateCategories')}
            labelattr='text' valueattr='value' />
        ),
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => (<DateField attr={attr} val={row[attr]} valN={row.valid_to} />),
        (attr, row) => (<DateField attr={attr} val={row[attr]} valN={row.valid_from} />)
      ]}
      rowId={(row) => (row.contractor_id)}
      EditForm={_FPrivateCategoriesForm}
      copyModalToggle={(store.cv.record.get(attr) && store.cv.record.get(attr).length) ? null : store.toggleFPCatsCopyModal}
      {...rest}
    />
    <FlyPrivateCatsCopyModal store={store} />
  </React.Fragment>
  )
}
export default FPrivateCategoriesEdit
